module.exports = __webpack_public_path__ + "img/0Q3A4704_L_Foamcore.193229d5.jpg";